import React from "react";

import env from "@/environment";
import BugsnagClient, { type Event } from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

/*
It's originating from datadog node_modules/@datadog/browser-core/src/tools/instrumentMethod.ts
and this error doesn't seem to be causing any problems, so we're going to ignore it for now.

https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
*/
export const checkIsResizeObserverError = (event: Event) => {
  let isResizeObserverError = false;
  event.errors.forEach((error) => {
    if (error.errorMessage.includes("ResizeObserver loop limit exceeded")) {
      isResizeObserverError = true;
    } else if (
      error.errorMessage.includes(
        "ResizeObserver loop completed with undelivered notifications",
      )
    ) {
      isResizeObserverError = true;
    }
  });

  return isResizeObserverError;
};

BugsnagClient.start({
  apiKey: env.bugsnagApiKey,
  plugins: [new BugsnagPluginReact(React)],
  onError: (event) => {
    const isResizeObserverError = checkIsResizeObserverError(event);
    if (isResizeObserverError) {
      // Return false to discard event
      return false;
    }
  },
});

export const bugsnagClient = BugsnagClient;
